import { useFormContext } from 'react-hook-form';

import StringInput from 'components/field/StringInput';
import FormItem from 'components/form/FormItem';

import BaseUrl from '../Fields/BaseUrl';
import * as S from '../SalesChannel.styled';

const ChannelEngine = ({ children }) => {
	const {
		formState: { isSubmitting, isLoading: isFormLoading }
	} = useFormContext();

	const isLoading = isSubmitting || isFormLoading;

	return (
		<S.StoreAccordion header="storeDetails" defaultVisible>
			<FormItem label="sc.storeName" isLoading={isLoading} required>
				<StringInput name="storeName" />
			</FormItem>
			<FormItem label="token" isLoading={isLoading} required>
				<StringInput name="token" />
			</FormItem>
			<BaseUrl isLoading={isLoading} required />

			{children}
		</S.StoreAccordion>
	);
};
export default ChannelEngine;
